import { SearchOutlined } from '@ant-design/icons';
import { IconButton, twClassMerge  } from '@healthhub/react-ui';
import type { InputRef } from 'antd';
import { Divider, Input } from 'antd';
import { forwardRef } from 'react';

import { OutlinedCloseIcon } from '@shared/assets-icon';


import styles from './styles.module.css';

interface SearchInputProps {
  isFocus: boolean;
  onBlur?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onInputBlur?: () => void;
  onInputFocus?: () => void;
  openSearchPage: () => void;
  updateSearchText: (text: string) => void;
  value?: string;
}

const SearchInput = forwardRef<InputRef, SearchInputProps>(
  (
    { openSearchPage, updateSearchText, isFocus, onBlur, onChange, onInputFocus, onInputBlur, value }: SearchInputProps,
    ref
  ) => {
    const onKeyDownSearchInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        openSearchPage();
      }
    };

    const onChangeSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
      updateSearchText(e.target.value);
    };

    const onClickSearchButton = () => {
      openSearchPage();
    };

    const onClearSearchInput = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      updateSearchText('');
      onBlur?.();
    };

    return (
      <Input
        className={twClassMerge('h-10 lg:w-[16.875rem] xl:w-96 rounded-lg flex', styles.searchInput)}
        onBlur={onInputBlur}
        onChange={(e) => {
          onChange?.(e);
          onChangeSearchInput(e);
        }}
        onFocus={onInputFocus}
        onKeyDown={onKeyDownSearchInput}
        placeholder="Search HealthHub"
        ref={ref}
        suffix={
          <div className="flex gap-2">
            <div className={twClassMerge('flex gap-2 invisible', isFocus && 'visible')}>
              <IconButton
                aria-label="Clear"
                icon={<OutlinedCloseIcon className="text-lg text-primary-blue-grey-3" />}
                onClick={onClearSearchInput}
              />
              <Divider className="m-0 h-8 border-functional-stone" type="vertical" />
            </div>
            <IconButton
              aria-label="Search"
              icon={<SearchOutlined className="text-lg text-primary-blue-grey-3" />}
              onClick={onClickSearchButton}
            />
          </div>
        }
        value={value}
      />
    );
  }
);

export default SearchInput;
